import { useTranslation } from "react-i18next";

import { router } from "../../app/services/router";
import { useAppSelector } from "../../app/store";
import { selectCurrentUser } from "../../app/store/auth";
import { A } from "../../features/shared/A";

export const SitemapNav = () => {
  const currentUser = useAppSelector(selectCurrentUser);

  const { t } = useTranslation();
  const items = t("features.core.SitemapNav") as unknown as {
    appendices: {
      links: Record<
        | "accessibility"
        | "fraudAlert"
        | "legalNotice"
        | "protectionPolicy"
        | "sitemap"
        | "termsOfService",
        { href?: string; text: string }
      >;
      title: string;
    };
    authenticated: {
      links: Record<
        | "home"
        | "mainAccount"
        | "mainAddContracts"
        | "mainContact"
        | "mainEServices"
        | "mainMessaging"
        | "mainOffers",
        { text: string }
      >;
      title: string;
    };
    unauthenticated: {
      links: Record<
        "authenticationForgotPassword" | "authenticationSignUp" | "home",
        { text: string }
      >;
      title: string;
    };
  };

  return (
    <>
      {[
        {
          key: "unauthenticated",
          ...items.unauthenticated,
          links: [
            {
              key: "home",
              ...items.unauthenticated.links.home,
              href: router.getTo("home"),
              visible: true,
            },
            {
              key: "authenticationSignUp",
              ...items.unauthenticated.links.authenticationSignUp,
              href: router.getTo("authenticationSignUp"),
              visible: true,
            },
            {
              key: "authenticationForgotPassword",
              ...items.unauthenticated.links.authenticationForgotPassword,
              href: router.getTo("authenticationForgotPassword"),
              visible: true,
            },
          ],
          visible: !currentUser,
        },
        {
          key: "authenticated",
          ...items.authenticated,
          links: [
            {
              key: "home",
              ...items.authenticated.links.home,
              href: router.getTo("home"),
              visible: true,
            },
            {
              key: "mainMessaging",
              ...items.authenticated.links.mainMessaging,
              href: router.getTo("mainMessaging"),
              visible: currentUser?.links.messaging,
            },
            {
              key: "mainEServices",
              ...items.authenticated.links.mainEServices,
              href: router.getTo("mainEServices"),
              visible: currentUser?.links.eServices,
            },
            {
              key: "mainOffers",
              ...items.authenticated.links.mainOffers,
              href: router.getTo("mainOffers"),
              visible: true,
            },
            {
              key: "mainContact",
              ...items.authenticated.links.mainContact,
              href: router.getTo("mainContact"),
              visible: true,
            },
            {
              key: "mainAccount",
              ...items.authenticated.links.mainAccount,
              href: router.getTo("mainAccount"),
              visible: true,
            },
            {
              key: "mainAddContracts",
              ...items.authenticated.links.mainAddContracts,
              href: router.getTo("mainAddContracts"),
              visible: true,
            },
          ],
          visible: currentUser,
        },
        {
          key: "appendices",
          ...items.appendices,
          links: [
            {
              key: "termsOfService",
              ...items.appendices.links.termsOfService,
              href: router.getTo("termsOfService"),
              visible: true,
            },
            {
              key: "legalNotice",
              ...items.appendices.links.legalNotice,
              href: router.getTo("legalNotice"),
              visible: true,
            },
            {
              key: "sitemap",
              ...items.appendices.links.sitemap,
              href: router.getTo("sitemap"),
              visible: true,
            },
            {
              key: "protectionPolicy",
              ...items.appendices.links.protectionPolicy,
              href: items.appendices.links.protectionPolicy.href as string,
              visible: true,
            },
            {
              key: "fraudAlert",
              ...items.appendices.links.fraudAlert,
              href: items.appendices.links.fraudAlert.href as string,
              visible: true,
            },
            {
              key: "accessibility",
              ...items.appendices.links.accessibility,
              href: router.getTo("accessibility"),
              visible: true,
            },
          ],
          visible: true,
        },
      ].map((nav) =>
        nav.visible ? (
          <nav key={nav.key}>
            <h2>{nav.title}</h2>
            <ul>
              {nav.links.map((link) =>
                link.visible ? (
                  <li key={link.key}>
                    <A href={link.href}>{link.text}</A>
                  </li>
                ) : null,
              )}
            </ul>
          </nav>
        ) : null,
      )}
    </>
  );
};
